import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

/* ============== 价目表（价盘） ============== */

// 价目表分页列表（page 从 0 开始；不传分页参数返回全量）
export const findPriceBookPage = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook?` + params,
    method: 'GET',
  });
};

// 价目表详情
export const getPriceBookDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/${id}`,
    method: 'GET',
  });
};

// 新建价目表
export const addPriceBook = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook`,
    method: 'POST',
    timeout: 30000,
    data,
  });
};

// 编辑价目表（状态请通过价盘主表审批暂存提交）
export const updatePriceBook = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook`,
    method: 'PUT',
    timeout: 30000,
    data,
  });
};

// 删除价目表（兼容旧调用：改为提交审批，审批通过后级联删除）
export const deletePriceBook = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/${ids}`,
    method: 'DELETE',
  });
};

// 复制价目表（包含计价项标准价、吊顶型号标准价和全部商户价）
export const copyPriceBook = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/${id}/copy`,
    method: 'POST',
  });
};

// 批量提交价盘主表操作审批（启用、停用、草稿生效、删除）
export const submitPriceBookActionBatch = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/batchSubmit`,
    method: 'POST',
    data,
  });
};

// 吊顶型号基价回显（不分页，直接返回数组 [{id, goodsFilterId, goodsFilterName, price, status}]）
export const findPriceBookFilterPrice = (priceBookId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/filterPrice?priceBookId=${priceBookId}`,
    method: 'GET',
  });
};

/* ============== 价盘商户价 ============== */

// 商户价列表（priceBookId 必填）
export const findPriceBookMerchant = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant?` + params,
    method: 'GET',
  });
};

// 商户汇总列表（按商户分页）
export const findPriceBookMerchantSummary = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/summary?` + params,
    method: 'GET',
  });
};

// 指定商户的全部价格明细
export const findPriceBookMerchantDetails = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/details?` + params,
    method: 'GET',
  });
};

// 新增商户价
export const addPriceBookMerchant = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant`,
    method: 'POST',
    data,
  });
};

// 批量提交商户价调整审批（新增、改价/启停、删除可混合提交）
export const submitPriceBookMerchantBatch = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/batchSubmit`,
    method: 'POST',
    timeout: 30000,
    data,
  });
};

// 编辑商户价（仅允许改 price、status）
export const updatePriceBookMerchant = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant`,
    method: 'PUT',
    data,
  });
};

// 删除商户价（ids 逗号分隔批量）
export const deletePriceBookMerchant = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/${ids}`,
    method: 'DELETE',
  });
};

/* ============== 商户价 Excel 批量导入（三步） ============== */

// 第 1 步：下载导入模板（xlsx）；路径必须以 /downloadExcel 结尾（网关对文件下载请求的放行规则）
export const downloadMerchantImportTemplate = (priceBookId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/importTemplate/downloadExcel?priceBookId=${priceBookId}`,
    method: 'GET',
    responseType: 'blob',
  });
};

// 第 2 步：上传预览（不写库）；formData: file、priceBookId、mode(INSERT/OVERWRITE)
// 注意：必须传 ContentType，否则 axios 拦截器会把 FormData 当 JSON.stringify 导致参数丢失
export const previewMerchantImport = (formData) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/importPreview`,
    method: 'POST',
    ContentType: 'multipart/form-data',
    data: formData,
  });
};

// 第 3 步：确认导入（整批事务）；data: { priceBookId, mode, rows }
export const confirmMerchantImport = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceBook/merchant/importConfirm`,
    method: 'POST',
    data,
  });
};
